export default __webpack_public_path__ + "static/media/equipos.b2c17ba8.svg";